
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'

// Initialize Sentry before rendering the app
initSentry().then(() => {
  console.log('Sentry initialized successfully');
}).catch((error) => {
  console.warn('Sentry initialization failed:', error);
}).finally(() => {
  // Render the app regardless of Sentry initialization status
  createRoot(document.getElementById("root")!).render(<App />);
});
